import { render, staticRenderFns } from "./email-sent.vue?vue&type=template&id=76c56b45&"
import script from "./email-sent.vue?vue&type=script&lang=js&"
export * from "./email-sent.vue?vue&type=script&lang=js&"
import style0 from "./email-sent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports